import API from '../..';
const ENTITY = 'panels-catalog';

export const filterPanelsList = (brandName) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            brand: brandName,
        },
    });
export const getPanelBrands = () => API.get(`/api/v1/${ENTITY}/brands/`);
